import axios from "axios";
import axiosInstance from "./axiosInstance";


class EmailAcompanhamentoPublicacao {
    cancelTokens = {
        cadastrarEmail: null,
        removerEmail: null,
        alterarFrequencia: null,
        alterarPreferencias: null,
        getPreferencias: null,
    };

    isCancel(exceptionThrown) {
        return axios.isCancel(exceptionThrown);
    }

    async cadastrarEmail({
        nome,
        frequencia,
        paisId,
        estadoId,
        email,
        receberEstadual,
        todosMunicipios,
        entesFederativosIds
    }) {
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();

        this.cancelTokens.cadastrarEmail = source;

        const { data } = await axiosInstance.post(
            `${process.env.VUE_APP_BASE_API_URL}/api/v1/emails_acompanhamento_legislacoes`,
            {
                nome,
                frequencia: frequencia,
                pais_id: paisId,
                estado_id: estadoId,
                email,
                receber_estadual: receberEstadual !== false,
                todos_municipios: !!todosMunicipios,
                entes_federativos_ids: entesFederativosIds || [],
            },
            {
                cancelToken: source.token,
            }
        );

        this.cancelTokens.cadastrarEmail = null;

        return data;
    }

    async alterarFrequencia({
        frequencia,
        email
    }) {
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();

        this.cancelTokens.alterarFrequencia = source;

        const { data } = await axiosInstance.put(
            `${process.env.VUE_APP_BASE_API_URL}/api/v1/emails_acompanhamento_legislacoes/alterar_frequencia?email=${email}`,
            {
                frequencia: frequencia,
                email,
            },
            {
                cancelToken: source.token,
            }
        );

        this.cancelTokens.alterarFrequencia = null;

        return data;
    }

    // Leitura de preferências exige o token assinado que vem no link do e-mail.
    async getPreferencias({ token }) {
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();

        this.cancelTokens.getPreferencias = source;

        const { data } = await axiosInstance.get(
            `${process.env.VUE_APP_BASE_API_URL}/api/v1/emails_acompanhamento_legislacoes/preferencias`,
            {
                params: { token },
                cancelToken: source.token,
            }
        );

        this.cancelTokens.getPreferencias = null;

        return data;
    }

    async alterarPreferencias({ token, frequencia, receberEstadual, todosMunicipios, entesFederativosIds }) {
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();

        this.cancelTokens.alterarPreferencias = source;

        const { data } = await axiosInstance.put(
            `${process.env.VUE_APP_BASE_API_URL}/api/v1/emails_acompanhamento_legislacoes/alterar_preferencias`,
            {
                token,
                frequencia,
                receber_estadual: receberEstadual !== false,
                todos_municipios: !!todosMunicipios,
                entes_federativos_ids: entesFederativosIds || [],
            },
            {
                cancelToken: source.token,
            }
        );

        this.cancelTokens.alterarPreferencias = null;

        return data;
    }

    async removerEmail({ email }) {
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();

        this.cancelTokens.removerEmail = source;

        const { data } = await axiosInstance.delete(
            `${process.env.VUE_APP_BASE_API_URL}/api/v1/emails_acompanhamento_legislacoes/remover?email=${email}`,
            {
                cancelToken: source.token,
            }
        );

        this.cancelTokens.removerEmail = null;

        return data;
    }
}

export default EmailAcompanhamentoPublicacao;
